import Spectrum1 from "../../images/HU_Con_112_PCG1024_1.jpg"
import Spectrum2 from "../../images/HU_Con_112_PCG1024_2.jpg"
import Spectrum3 from "../../images/HU_Con_112_PCG1024_3.jpg"
import Spectrum4 from "../../images/HU_Con_112_PCG1024_4.jpg"
import Spectrum5 from "../../images/HU_Con_112_PCG1024_5.jpg"
import Spectrum6 from "../../images/HU_Con_112_PCG1024_6.jpg"
import Spectrum7 from "../../images/HU_Con_112_PCG1024_7.jpg"
import Spectrum8 from "../../images/HU_Con_112_PCG1024_8.jpg"
import Spectrum9 from "../../images/HU_Con_112_PCG1024_9.jpg"
import Spectrum10 from "../../images/HU_Con_112_PCG1024_10.jpg"
import Spectrum11 from "../../images/HU_Con_112_PCG1024_11.jpg"
import Spectrum12 from "../../images/HU_Con_112_PCG1024_12.jpg"
import Spectrum13 from "../../images/HU_Con_112_PCG1024_13.jpg"
import Spectrum14 from "../../images/HU_Con_112_PCG1024_14.jpg"
import Spectrum15 from "../../images/HU_Con_112_PCG1024_15.jpg"
import Spectrum16 from "../../images/HU_Con_112_PCG1024_16.jpg"
import Spectrum17 from "../../images/HU_Con_112_PCG1024_17.jpg"
import Spectrum18 from "../../images/HU_Con_112_PCG1024_18.jpg"
import Spectrum19 from "../../images/HU_Con_112_PCG1024_19.jpg"
import Spectrum20 from "../../images/HU_Con_112_PCG1024_20.jpg"
import Spectrum21 from "../../images/HU_Con_112_PCG1024_21.jpg"
import Spectrum22 from "../../images/HU_Con_112_PCG1024_22.jpg"
import Spectrum23 from "../../images/HU_Con_112_PCG1024_23.jpg"
import Spectrum24 from "../../images/HU_Con_112_PCG1024_24.jpg"
import Spectrum25 from "../../images/HU_Con_112_PCG1024_25.jpg"

const spectrumSeries = [
  Spectrum1,
  Spectrum2,
  Spectrum3,
  Spectrum4,
  Spectrum5,
  Spectrum6,
  Spectrum7,
  Spectrum8,
  Spectrum9,
  Spectrum10,
  Spectrum11,
  Spectrum12,
  Spectrum13,
  Spectrum14,
  Spectrum15,
  Spectrum16,
  Spectrum17,
  Spectrum18,
  Spectrum19,
  Spectrum20,
  Spectrum21,
  Spectrum22,
  Spectrum23,
  Spectrum24,
  Spectrum25,
]

export default spectrumSeries
